export enum NotificationTypes {
  Information = 'Info',
  Success = 'Success',
  Warning = 'Warning',
  Error = 'Error'
}

export enum NotificationParamTypes {
  Text = 'Text',
  Currency = 'Currency',
  Percentage = 'Percentage'
}
